// /src/ProcessingBar.jsx
import React from 'react';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.6; }
  50% { transform: scale(1.3); opacity: 1; }
  100% { transform: scale(1); opacity: 0.6; }
`;

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
`;

const Dots = styled.div`
  display: flex;
  gap: 10px;
`;

const Dot = styled.div`
  width: 12px;
  height: 12px;
  background: #00B2FF;
  border-radius: 50%;
  animation: ${pulse} 1.2s ease-in-out infinite;
  animation-delay: ${props => props.delay};
`;

const Text = styled.p`
  margin-bottom: 15px;
  font-size: 1rem;
  color: #aaa;
`;

function ProcessingBar() {
  return (
    <LoaderWrapper>
      <Text>Aitoxa is thinking...</Text>
      <Dots>
        <Dot delay="0s" />
        <Dot delay="0.2s" />
        <Dot delay="0.4s" />
      </Dots>
    </LoaderWrapper>
  );
}

export default ProcessingBar;